import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormControl,
  FormsModule,
  FormArray,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RfqSectionDialogsComponent } from '../rfq-section-dialogs.component';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { environment } from '@/app/environments/environment';
import { ApiErrorResponse } from '@/app/interfaces/apiErrorResponse.interface';
import { MessagesEnum } from '@/app/enums/message.enum';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
import { RequestForQuotationService } from '@/app/services/tendering-services/rfq/rfq.service';
// TODO: for now commenting out the interface as data is changing.
// import { tendererServiceAdding } from '@/app/interfaces/tendererDialogs.interface';

@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    RichTextEditorComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-rfq-construction-work',
  templateUrl: './rfq-construction-work.component.html',
  styleUrls: ['./rfq-construction-work.component.css'],
})
export class RfqConstructionWorkComponent implements OnInit {
  constructor(
    private RfqSectionDialogsComponent: RfqSectionDialogsComponent,
    private projectsService: ProjectsService,
    private toast: NgToastService,
    private router: Router,
    private requestForQuotationService: RequestForQuotationService,
    private getFileIconService: GetFileIconUtilityService
  ) {}
  @Output() closeModalEvent = new EventEmitter<boolean>();
  @Output() constructionWorksDataEmitter: EventEmitter<any> =
    new EventEmitter<any>();

  // when all is done, will remove rfpResponseData and rename tendererResponseData to rfpResponseData
  @Input() rfpResponseData: any;
  @Input() tendererResponseData: any;

  base_path = environment.storageUrl;
  resetRichTextEditor = false;
  isEdit = false;
  eoiTitle: FormControl<any>;
  submittedGuidlines: any;

  form: FormGroup = new FormGroup({
    site_preparation_control: new FormControl('', Validators.required),
    civil_works_control: new FormControl('', Validators.required),
    mep_works_control: new FormControl('', Validators.required),
    fit_out_control: new FormControl('', Validators.required),
    health_safety_control: new FormControl('', Validators.required),
    post_construction_control: new FormControl('', Validators.required),
    site_preparation_file_control: new FormArray([], Validators.required),
    structure_civil_file_control: new FormArray([], Validators.required),
    health_safety_file_control: new FormArray([], Validators.required),
  });

  closeModal = true;

  oldSitePreparationFiles = [];
  deletedSitePreparationFiles = [];

  oldStructureCivilFiles = [];
  deletedStructureCivilFiles = [];

  oldHealthSafetyFiles = [];
  deletedHealthSafetyFiles = [];

  ngOnInit(): void {
    this.requestForQuotationService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });
    // if (this.form) {
    //   this.mapExistingData();
    // }

    if (this.tendererResponseData) {
      this.mapRFPExistingData();
    }
    this.setValidatorsBasedOnFileData();
  }
  setSitePreparation(content: string) {
    this.form.controls['site_preparation_control'].setValue(content);
  }
  setStructuralCivilWorks(content: string) {
    this.form.controls['civil_works_control'].setValue(content);
  }
  setMEPWorks(content: string) {
    this.form.controls['mep_works_control'].setValue(content);
  }
  setFitOut(content: string) {
    this.form.controls['fit_out_control'].setValue(content);
  }
  setHealthSafetyCompliance(content: string) {
    this.form.controls['health_safety_control'].setValue(content);
  }
  setPostConstruction(content: string) {
    this.form.controls['post_construction_control'].setValue(content);
  }

  get site_preparation_file_control(): FormArray {
    return this.form.get('site_preparation_file_control') as FormArray;
  }
  get structure_civil_file_control(): FormArray {
    return this.form.get('structure_civil_file_control') as FormArray;
  }
  get health_safety_file_control(): FormArray {
    return this.form.get('health_safety_file_control') as FormArray;
  }

  isImageFile(file: any) {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    let fileExtension: any;

    if (this.isEdit && !file?.name) {
      fileExtension = file?.split('.').pop()?.toLowerCase();
    } else if (this.isEdit && file?.name) {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    } else {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    }
    return imageExtensions.includes(fileExtension || '');
  }

  onFileUpload(event: any, currentControl: string): void {
    const files = event.target.files;
    console.log('The files are:', files);
    let control: any;

    if (files && files.length > 0) {
      if (currentControl === 'site_preparation_file_control') {
        control = this.form.get('site_preparation_file_control') as FormArray;
      } else if (currentControl === 'structure_civil_file_control') {
        control = this.form.get('structure_civil_file_control') as FormArray;
      } else if (currentControl === 'health_safety_file_control') {
        control = this.form.get('health_safety_file_control') as FormArray;
      }
      Array.from(files).forEach((file: any) => {
        control.push(new FormControl(file));
      });
    }
  }

  // Remove new file
  removeFile(index: number, controlName: string): void {
    const control = this.form.get(controlName) as FormArray;
    control.removeAt(index); // Remove file at index
  }

  // Remove old file
  removeOldFile(index: number, id: number, controlName: string): void {
    switch (controlName) {
      case 'site_preparation_file_control':
        this.deletedSitePreparationFiles.push(id);
        this.oldSitePreparationFiles.splice(index, 1);
        break;

      case 'structure_civil_file_control':
        this.deletedStructureCivilFiles.push(id);
        this.oldStructureCivilFiles.splice(index, 1);
        break;

      case 'health_safety_file_control':
        this.deletedHealthSafetyFiles.push(id);
        this.oldHealthSafetyFiles.splice(index, 1);
        break;

      default:
        console.warn(`Unknown control name: ${controlName}`);
        break;
    }
  }

  moveToPreviousStep() {
    this.RfqSectionDialogsComponent.previousStep();
  }

  prepareDataToSubmit() {
    if (this.form.valid) {
      const dataToSubmit = new FormData();
      dataToSubmit.append(
        'site_preparation',
        this.form.value.site_preparation_control
      );
      dataToSubmit.append(
        'structural_civil_works',
        this.form.value.civil_works_control
      );
      dataToSubmit.append('mep_works', this.form.value.mep_works_control);
      dataToSubmit.append('finishing_fitout', this.form.value.fit_out_control);
      dataToSubmit.append(
        'health_safety_compliance',
        this.form.value.health_safety_control
      );
      dataToSubmit.append(
        'post_construction_activities',
        this.form.value.post_construction_control
      );

      this.form.value.site_preparation_file_control.forEach(
        (uploadedFile: File) => {
          if (uploadedFile) {
            dataToSubmit.append('site_preparation_file[]', uploadedFile);
          }
        }
      );
      dataToSubmit.append(
        'deletedSitePreparationFiles[]',
        JSON.stringify(this.deletedSitePreparationFiles)
      );

      this.form.value.structure_civil_file_control.forEach(
        (uploadedFile: File) => {
          if (uploadedFile) {
            dataToSubmit.append('structure_civil_file[]', uploadedFile);
          }
        }
      );

      dataToSubmit.append(
        'deletedStructureCivilFiles[]',
        JSON.stringify(this.deletedStructureCivilFiles)
      );

      this.form.value.health_safety_file_control.forEach(
        (uploadedFile: File) => {
          if (uploadedFile) {
            dataToSubmit.append('health_safety_file[]', uploadedFile);
          }
        }
      );
      dataToSubmit.append(
        'deletedHealthSafetyFiles[]',
        JSON.stringify(this.deletedHealthSafetyFiles)
      );
      return dataToSubmit;
    }
  }

  moveToNextStep() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.toast.warning(MessagesEnum.REQUIRED_ALL_FIELDS, 'WARNING', 4000);
      return;
    } else {
      const dataToSubmit = this.prepareDataToSubmit();
      this.requestForQuotationService
        .addRfqConstructionWork(dataToSubmit)
        .subscribe({
          next: (response: any) => {
            if (response?.meta?.success) {
              this.toast.success(response?.meta?.message, 'SUCCESS');
              this.constructionWorksDataEmitter.emit(response?.data);
              this.RfqSectionDialogsComponent.nextStep();
            }
          },
          error: (error: ApiErrorResponse) => {
            console.error(error.error.message, error);
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
    }
  }
  handleBack() {
    this.requestForQuotationService.setEditState(true);
    this.RfqSectionDialogsComponent.previousStep();
  }

  mapRFPExistingData() {
    if (!this.tendererResponseData) {
      console.warn('Tenderer Response Data is undefined');
      return;
    }

    this.form.patchValue({
      site_preparation_control:
        this.tendererResponseData?.sitePreparation ?? '',
      civil_works_control: this.tendererResponseData?.civilWorks ?? '',
      mep_works_control: this.tendererResponseData?.mepWorks ?? '',
      fit_out_control: this.tendererResponseData?.fitOut ?? '',
      health_safety_control: this.tendererResponseData?.healthSafety ?? '',
      post_construction_control:
        this.tendererResponseData?.postConstruction ?? '',
    });

    this.oldSitePreparationFiles =
      this.tendererResponseData?.sitePreparationAttachments ?? [];
    this.oldStructureCivilFiles =
      this.tendererResponseData?.civilWorksAttachments ?? [];
    this.oldHealthSafetyFiles =
      this.tendererResponseData?.healthSafetyAttachments ?? [];
  }

  // Dynamically set validator for the site preparation files,health safety files,structure civil files
  setValidatorsBasedOnFileData() {
    // Handle site preparation control
    if (this.oldSitePreparationFiles?.length > 0) {
      this.form.get('site_preparation_file_control')?.clearValidators();
    } else {
      this.form
        .get('site_preparation_file_control')
        ?.setValidators(Validators.required);
    }

    // Handle health safety control
    if (this.oldHealthSafetyFiles?.length > 0) {
      this.form.get('health_safety_file_control')?.clearValidators();
    } else {
      this.form
        .get('health_safety_file_control')
        ?.setValidators(Validators.required);
    }

    // Handle structure civil control
    if (this.oldStructureCivilFiles?.length > 0) {
      this.form.get('structure_civil_file_control')?.clearValidators();
    } else {
      this.form
        .get('structure_civil_file_control')
        ?.setValidators(Validators.required);
    }

    // Update form controls' validity
    this.form.get('site_preparation_file_control')?.updateValueAndValidity();
    this.form.get('health_safety_file_control')?.updateValueAndValidity();
    this.form.get('structure_civil_file_control')?.updateValueAndValidity();
  }
  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
}
